import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Navbar from '../../components/Navbar';
import AdminOverview from '../../components/admin/AdminOverview';
import AdminVendors from '../../components/admin/AdminVendors';
import AdminUsers from '../../components/admin/AdminUsers';
import AdminWaitingList from '../../components/admin/AdminWaitingList';
import usePageTitle from '../../hooks/usePageTitle';
import { LayoutDashboard, Store, Users, Mail, Loader } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = ({ user, onLogout }) => {
  usePageTitle('Admin Dashboard');
  const [activeTab, setActiveTab] = useState('overview');
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
      toast.error('Fehler beim Laden der Statistiken');
    } finally {
      setStatsLoading(false);
    }
  };

  const tabs = [
    { value: 'overview', label: 'Übersicht', shortLabel: 'Übersicht', icon: LayoutDashboard },
    { value: 'vendors', label: 'Dienstleister', shortLabel: 'Anbieter', icon: Store },
    { value: 'users', label: 'Benutzer', shortLabel: 'Nutzer', icon: Users },
    { value: 'waitinglist', label: 'Warteliste', shortLabel: 'Warteliste', icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF0D1]/30 via-white to-[#F4F2F2]">
      <Navbar user={user} onLogout={onLogout} />

      <div className="pt-24 pb-12 px-4">
        <div className="container max-w-7xl">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
            <p className="text-gray-600">Verwaltung und Überwachung der Plattform</p>
          </div>

          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full flex overflow-x-auto bg-white rounded-2xl shadow-lg p-1.5 mb-8 gap-1">
              {tabs.map(({ value, label, shortLabel, icon: Icon }) => (
                <TabsTrigger
                  key={value}
                  value={value}
                  className="flex-1 min-w-0 flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium transition-all data-[state=active]:bg-[#2B2142] data-[state=active]:text-white data-[state=active]:shadow-md"
                >
                  <Icon className="w-4 h-4 flex-shrink-0" />
                  <span className="hidden sm:inline truncate">{label}</span>
                  <span className="sm:hidden truncate">{shortLabel}</span>
                </TabsTrigger>
              ))}
            </TabsList>

            <TabsContent value="overview">
              {statsLoading ? (
                <div className="flex items-center justify-center py-12"><Loader className="w-8 h-8 animate-spin text-[#2B2142]" /></div>
              ) : (
                <AdminOverview stats={stats} />
              )}
            </TabsContent>

            <TabsContent value="vendors">
              <AdminVendors />
            </TabsContent>

            <TabsContent value="users">
              <AdminUsers />
            </TabsContent>

            <TabsContent value="waitinglist">
              <AdminWaitingList />
            </TabsContent>

          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
